import { COMPANY_ROUTE } from '@constants'

export const API_ONBOARDING_DOCUMENTS_URL = `${COMPANY_ROUTE}autotax-onboarding/documents/`
export const API_ONBOARDING_DOCUMENT_URL = `${API_ONBOARDING_DOCUMENTS_URL}{document_id}/`
